const BASE_URL = process.env.VUE_APP_PROCESSING_CENTER_URL || "https://proc.makemymosaic.de/";
export const API_URL = BASE_URL + "api/";
export const STORAGE_URL = BASE_URL + "storage/";


export const IMAGE_COMPRESSION_OPTIONS = {
    quality: 0.85,
    maxWidth: 4096,
    maxHeight: 4096,
    sizeThreshold: 8 * 1024 * 1024,
    convertSize: Infinity
};

// Tile images are printed at tile_size x 300 dpi (a few hundred pixels), so
// 2048 px is far more than the generator ever uses. Compressing every tile keeps
// a 300-photo upload at a fraction of the original size, which matters on mobile.
export const TILE_COMPRESSION_OPTIONS = {
    quality: 0.8,
    maxWidth: 2048,
    maxHeight: 2048,
    sizeThreshold: 600 * 1024,
    convertSize: 2 * 1024 * 1024
};
